import React, { Component } from 'react';
import UserLogin from "./userLogin";
import UserReset from "./userResetPassword";
import UserForgot from "./userForgotPassword";
import Loading from "./loading";

class LoginBox extends Component {
	render() {
		let content = this._actionPane();
		let {isFetching, message} = this.props.userLogin;
		return <div className="columns login-box">
				<div className="column">
					<div className="columns is-centered">
						<div className="column is-10">
							{isFetching ? <Loading message={message} /> : content}
						</div>
					</div>
				</div>

				<a className="login-box--notification" href="http://etransversalidad2-0.inmujeres.gob.mx/" target="_blank">
					Acceder a versión 2020 <i className="fa fa-external-link" />
				</a>
			</div>
	}

	_actionPane = () => {
		switch(this.props.action) {
			case 'reset':
				return <UserReset setActionType={this.props.setActionType} userReset={this.props.userReset} error={this.props.userLogin.error} message={this.props.userLogin.message} query={this.props.query} />;
			case 'forgot':
				return <UserForgot setActionType={this.props.setActionType} userRecover={this.props.userRecover} message={this.props.userLogin.message} error={this.props.userLogin.error} />
			default:
				return <UserLogin setActionType={this.props.setActionType} user={this.props.user} login={this.props.login} register={this.props.register} error={this.props.userLogin.error} message={this.props.userLogin.message} />
		}
	}
}

export default LoginBox;


// WEBPACK FOOTER //
// ./src/elements/login/login.jsx